import type { ColorModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useSemanticModifierValue } from "@agent-ui/features/modifiers/hooks/useSemanticModifierValue";
import { parseColorValue } from "@agent-ui/features/modifiers/utils/parseComputedValue";
import ColorSelector from "@v2/features/modifiers/base/ColorSelector";

interface TextColorModifierProps {
  onChange: (modifiers: ColorModifierValue[]) => void;
}

const TextColorModifierComponent: React.FC<TextColorModifierProps> = ({
  onChange,
}) => {
  // NOTE (Derek, 2026-02-05): Use semantic modifier value to support semantic selection
  const currentColor = useSemanticModifierValue({
    semanticExtractor: ({ computedStyles }) => {
      return parseColorValue(computedStyles.color) ?? undefined;
    },
  });

  const handleColorChange = (color: string | null) => {
    const modifier: ColorModifierValue = {
      type: "color",
      value: color,
    };
    onChange([modifier]);
  };

  return <ColorSelector value={currentColor} onChange={handleColorChange} />;
};

export default TextColorModifierComponent;
